"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @description Обертка над navigator.sendBeacon() с полифиллом для ie (см. README).
 */
function sendBeacon(url, data, sync) {
    if (window.navigator && typeof window.navigator.sendBeacon === 'function') {
        return window.navigator.sendBeacon(url, data);
    }
    else {
        return sendBeaconPolyfill(url, data, sync);
    }
}
exports.sendBeacon = sendBeacon;
function sendBeaconPolyfill(url, data, sync) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', url, sync);
    xhr.withCredentials = true;
    xhr.setRequestHeader('Accept', '*/*');
    xhr.setRequestHeader('Content-Type', 'text/plain;charset=UTF-8');
    try {
        xhr.send(data);
    }
    catch (error) {
        return false;
    }
    return true;
}
//# sourceMappingURL=sendBeacon.js.map